/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  ResolveDirectoryReviewItemForm,
  ResolveDirectoryReviewItemForm$Outbound,
  ResolveDirectoryReviewItemForm$outboundSchema,
} from "../components/resolvedirectoryreviewitemform.js";

export type ResolveDirectoryReviewItemSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ResolveDirectoryReviewItemRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  resolveDirectoryReviewItemForm: ResolveDirectoryReviewItemForm;
};

/** @internal */
export type ResolveDirectoryReviewItemSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ResolveDirectoryReviewItemSecurity$outboundSchema: z.ZodMiniType<
  ResolveDirectoryReviewItemSecurity$Outbound,
  ResolveDirectoryReviewItemSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function resolveDirectoryReviewItemSecurityToJSON(
  resolveDirectoryReviewItemSecurity: ResolveDirectoryReviewItemSecurity,
): string {
  return JSON.stringify(
    ResolveDirectoryReviewItemSecurity$outboundSchema.parse(
      resolveDirectoryReviewItemSecurity,
    ),
  );
}

/** @internal */
export type ResolveDirectoryReviewItemRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  ResolveDirectoryReviewItemForm: ResolveDirectoryReviewItemForm$Outbound;
};

/** @internal */
export const ResolveDirectoryReviewItemRequest$outboundSchema: z.ZodMiniType<
  ResolveDirectoryReviewItemRequest$Outbound,
  ResolveDirectoryReviewItemRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    resolveDirectoryReviewItemForm:
      ResolveDirectoryReviewItemForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      resolveDirectoryReviewItemForm: "ResolveDirectoryReviewItemForm",
    });
  }),
);

export function resolveDirectoryReviewItemRequestToJSON(
  resolveDirectoryReviewItemRequest: ResolveDirectoryReviewItemRequest,
): string {
  return JSON.stringify(
    ResolveDirectoryReviewItemRequest$outboundSchema.parse(
      resolveDirectoryReviewItemRequest,
    ),
  );
}
